import React from "react";

interface Props {
  colorClass?: string;
  widthClass?: string;
}

export const Divider: React.FC<Props> = ({
  colorClass = "bg-grayscale-contrast-10",
  widthClass = "w-full",
}) => {
  return <hr className={`h-[1px] ${colorClass} ${widthClass}`} />;
};
